import React from 'react';
const TwoStepSessionTimedOutMessageBody = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "As a security measure, Marketplace partners must complete two-step verification to manage their organization\u2019s account."), /*#__PURE__*/React.createElement("p", null, "You will need to verify your identity to continue. Any unsaved changes will be lost."));
export const twoStepSessionTimedOutModalMessage = {
  header: 'Verify your identity',
  body: /*#__PURE__*/React.createElement(TwoStepSessionTimedOutMessageBody, null),
  cta: 'Verify',
  dismissCTA: 'Cancel'
};